// @flow

import * as React from 'react';

import { Base, TypoListItem } from '@gandi/ui';

type Props = {
  children: string,
};

export default function ErrorItem({ children }: Props): React.MixedElement {
  return (
    <TypoListItem icon="dangerWire" iconTheme="danger">
      <Base tagName="p" margin="none">
        {children}
      </Base>
    </TypoListItem>
  );
}
